import React, { useContext, createContext, useState } from "react";

const keycloakUsersFormContext = createContext();

export const ProvideKeycloakUsersForm = ({ children }) => {
  	// state for use with Keycloak users form context
	const [selectedKeycloakUsers , _setSelectedKeycloakUsers ] = useState(getEditingKeycloakUsersLocalStorage() || null);
	const setSelectedKeycloakUsers = users => {
		_setSelectedKeycloakUsers(users);
		setEditingKeycloakUsersLocalStorage(users);
	}
  const value = {
    selectedKeycloakUsers,
    setSelectedKeycloakUsers,
  };
  return <keycloakUsersFormContext.Provider value={value}>{children}</keycloakUsersFormContext.Provider>
}

export const useKeycloakUsersFormContext = () => useContext(keycloakUsersFormContext);

const keycloakUserLocalStorageKey = "selectedKeycloakUsers";

// setEditingKeycloakUsersLocalStorage(users: Array<Object> | null): void
export const setEditingKeycloakUsersLocalStorage = users => window.localStorage.setItem(keycloakUserLocalStorageKey, JSON.stringify(users));

// getEditingKeycloakUsersLocalStorage(): Array<Object> | null
export const getEditingKeycloakUsersLocalStorage = () => JSON.parse(window.localStorage.getItem(keycloakUserLocalStorageKey));